module.exports = __webpack_public_path__ + "static/media/logo-traycorp.b806f271.svg";